//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      // key: value
    }
  },
  props: {
    institution: {
      type: String,
      default: ''
    },
    schemeCurrent: {
      type: [Array, Object],
      default() {
        return []
      }
    },
    allData: {
      type: Object,
      default() {
        return {}
      }
    },
    lableTop: {
      type: Boolean,
      default: false
    },
    lableRight: {
      type: Boolean,
      default: false
    },
    btnProps: {
      type: Object,
      default() {
        return { style: { 'background-color': this.allData.insureBtnColor } }
      }
    }
  },
  methods: {
    receive() {
      this.$emit('receive')
    },
  },
}
